module.exports = __webpack_public_path__ + "img/vegetable-jicama-190x100.0a89c203.jpg";